<style scoped>
  .approval-words{font-size: 14px;color: #464c5b;line-height: 80px;padding-left: 20px;font-weight: bold;}
  .catalog{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 80px;cursor: pointer;margin-right:40px}
  .list-panel{background-color: white;padding:0 40px}
  .list-title{color: #464c5b;font-size: 16px;font-weight: bold;}
  .list-schedule{color: #657180;font-size: 14px;}
  .list-host-text{font-size: 14px;color: #626c70;display: inline-block;margin-right: 19px;vertical-align: text-top;}
  .list-host-avatar{width: 30px;height: 30px;border-radius: 15px;margin-right: 10px;}
  .list-pending{font-size: 14px;display: inline-block;vertical-align: text-top;margin-top: 4px;color: #00a2e9;}
  .list-panel >>> .ivu-switch-checked{background-color:#45db5e;border-color:#45db5e;}
  .enable{width: 70px;height: 20px;border-radius: 10px;}
  .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
</style>

<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <div style="background-color: #fff;">
      <Row style="height: 80px;border-bottom: 1px solid #d7dde4;">
        <Col span="20" class="approval-words">审批类型（点击列表可查看模板）</Col>
        <Col span="4" style="text-align: right">
          <!--<Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>新建-->
          <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: sub;"/>
          <p class="catalog" @click="editType.panel = true;editType.id = '';editType.name = ''">新建审批类型</p>
        </Col>
      </Row>
      <!---->
      <div class="list-panel">
        <Row justify="center">
          <Col v-for="(item,index) in list" span="24" style="height: 134px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;">
            <Col span="20" style="line-height: 38px;">
              <router-link :to="{name:'approvalModelList',query:{typeId:item.id}}">
                <div class="list-title">
                  {{item.name}}
                </div>
                <p class="list-schedule">创建日期：{{item.createTime}}</p>
              </router-link>
            </Col>
            <Col span="4">
              <p class="list-pending">
                <span style="cursor: pointer;" @click="editType.id=item.id;editType.name=item.name;editType.panel=true;">类型重命名</span> | <span style="cursor: pointer;" @click="deleteType(item.id)">删除类型</span>
              </p>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col span="24" style="margin:40px 0 57px 0;">
            <Page
                :show-sizer="true"
                :show-total="true"
                @on-page-size-change="search.pageSize=$event;getList()"
                :total="search.total"
                :page-size="search.pageSize"
                :page-size-opts="[5,10,15]"
                show-elevator
                @on-change="search.page = $event;getList()"
            />
          </Col>
        </Row>
        <Modal
            v-model="editType.panel"
            title="新增模板分类"
            @on-ok="editType.id?updateType():addType()"
            ok-text="保存"
        >
          <Row type="flex" align="middle" style="padding: 20px 0">
            <Col span="6" style="text-align: right">输入模板类别名称：</Col>
            <Col span="16"><Input v-model="editType.name" placeholder="输入模板类别名称"></Input></Col>
          </Row>
        </Modal>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "typelist",
    data() {
      return {
        editType:{
          panel:false,
          name:'',
          id:'',
        },
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        list:[],
        switch1:false,
      }
    },
    mounted:function(){
      this.getList()
    },
    methods: {
      deleteType:function(id){
        var _this = this
        _this.send({
          confirm:true,
          headers:'C/DeleteApprovalType',
          data:{
            ApprovalTypeId:id,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除分类成功！',
            })
          }
        })
      },
      updateType:function(){
        var _this = this
        _this.send({
          headers:'C/EditApprovalType',
          data:{
            ApprovalTypeTitle:_this.editType.name,
            ApprovalTypeId:_this.editType.id
          },
          success:function (res) {
            _this.editType.name = ''
            _this.editType.id = ''
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改审批类型信息成功！',
            })
          }
        })
      },
      addType:function(){
        var _this = this
        _this.send({
          headers:'C/AddApprovalType',
          data:{
            ApprovalTypeTitle:_this.editType.name
          },
          success:function (res) {
            _this.editType.name = ''
            _this.editType.id = ''
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加审批类型成功！',
            })
          }
        })
      },
      getList:function () {
        var _this = this
        _this.list = []
        _this.send({
          headers:'C/ShowApprovalType',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.list,i,{})
              _this.$set(_this.list[i],'id',res.List[index].ApprovalTypeId)
              _this.$set(_this.list[i],'name',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.list[i],'createTime',res.List[index].ApprovalTypeCreatedTime)
              i++
            }
            _this.search.total=res.Count
          }
        })
      },
    },
  }
</script>

